import React, { useCallback, useEffect, useRef } from 'react';

import LottieView from 'lottie-react-native';

import { StaticImages, useStaticLottieUri } from 'components/picture/static-image';
import { HapticsNotificationType, hapticNotification } from 'utils/haptic';
import { useLottieSource } from 'utils/lottie/use-lottie-source';

const SuccessAnimation = ({ onAnimationFinish }: { onAnimationFinish?: () => void }) => {
  const uri = useStaticLottieUri(StaticImages.LoyaltyOptInAnimation);
  const completionCalledRef = useRef(false);
  const { source, error } = useLottieSource({
    source: uri ? { uri } : undefined,
    surface: 'loyalty_claim_points',
  });

  const finishOnce = useCallback(() => {
    if (!completionCalledRef.current) {
      completionCalledRef.current = true;
      onAnimationFinish?.();
    }
  }, [onAnimationFinish]);

  useEffect(() => {
    hapticNotification({ type: HapticsNotificationType.SUCCESS });
  }, []);

  useEffect(() => {
    if (error) {
      finishOnce();
    }
  }, [error, finishOnce]);

  if (!source) {
    return null;
  }

  return <LottieView source={source} autoPlay loop={false} onAnimationFinish={finishOnce} />;
};

export default SuccessAnimation;
